const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/daily-briefs/$dailyBriefId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/ai/daily-briefs/$dailyBriefId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});